export default {
  billings(state) {
    return state.billings;
  },
  billing(state) {
    return state.billing;
  },
  filters(state) {
    return state.filters;
  },
  loading(state) {
    return state.loading;
  },
  currentUser(state) {
    return state.currentUser;
  },
  overdueBillings(state) {
    return state.billings.filter(
      (el) =>
        el.status === "overdue" ||
        el.status === "refused" ||
        el.status === "canceled",
    );
  },
  overdueTotal(state) {
    let total = 0;
    if (state.billings && state.billings.length > 0) {
      total = state.billings.reduce((accumulator, currentValue) => {
        let total_enercred = currentValue.total_enercred;

        if (currentValue.unique_billing === true) {
          total_enercred = currentValue.total - currentValue.total_invoice;
          if (
            currentValue.status === "overdue" ||
            currentValue.status === "refused" ||
            currentValue.status === "canceled"
          ) {
            return (accumulator += total_enercred);
          }
        } else {
          total_enercred = currentValue.total;
          if (
            currentValue.status === "overdue" ||
            currentValue.status === "refused" ||
            currentValue.status === "canceled"
          ) {
            return (accumulator += total_enercred);
          }
        }
        return accumulator;
      }, 0);
      return total;
    }
    return 0;
  },
  overdueBillingsIds(state) {
    const overdues = state.billings.filter(
      (el) =>
        el.status === "overdue" ||
        el.status === "refused" ||
        el.status === "canceled",
    );
    return overdues.map((el) => {
      // console.log(`${el.id} | ${el.status}`)
      return el.id;
    });
  },
  overdueConsumerUnits(state) {
    const overdues = state.billings.filter(
      (el) =>
        el.status === "overdue" ||
        el.status === "refused" ||
        el.status === "canceled",
    );
    // const distinctUCs = [...new Set(overdues.map(el => el))]
    const distinctUCs = state.consumer_units.filter((o1) =>
      overdues.some((o2) => o1.id === o2.consumer_unit),
    );
    return distinctUCs;
  },
  chargeParcel(state) {
    if (
      state.consumer_unit &&
      (state.consumer_unit.status === "canceled" ||
        state.consumer_unit.status === "canceling" ||
        state.consumer_unit.percentage === 0)
    )
      return "debt_billing";
    else return "billing";
  },
  consumerUnitFormType(state) {
    return state.consumer_unit_form_type;
  },
};
